export default "__VITE_ASSET__52ba4030__"